import Vue from "vue";
import Router from "vue-router";
import dashBoard from "../paginas/Dashboard.vue";
import store from "./store";
import { recadastramentoViewRouter } from './recadastramentoViewRouter'
import { recadastramentoRouter } from './recadastramentoRouter'
import { gerenciaChefiaRouter } from "./gerenciaChefiaRouter";
import { cadastroUsuarioRouter } from "./cadastroUsuarioRouter";
import { gestaoPessoaRouter } from "./gestaoPessoaRouter";

Vue.use(Router);



const router = new Router({
  mode: "history",
  // Não apagar esse comentario abaixo
  // eslint-disable-next-line no-sparse-arrays
  routes: [
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/parametrizacoes/consultarEmail",
      name: "CONSULTAR_EMAIL",
      meta: {
        auth: ['MANTER_EMAIL'],
      },
      component: () => import("@/paginas/parametrizacoes/consultarEmail.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/parametrizacoes/manterEmail",
      name: "MANTER_EMAIL",
      meta: {
        auth: ['MANTER_EMAIL'],
      },
      component: () => import("@/paginas/parametrizacoes/manterEmail.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/parametrizacoes/buscarAssunto",
      name: "BUSCAR_ASSUNTO",
      meta: {
        auth: ['MANTER_ASSUNTO'],
      },
      component: () => import("@/paginas/parametrizacoes/buscarAssunto.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL,
      name: "recadastramento",
      component: dashBoard,
    }, {
      path: "/" + process.env.VUE_APP_BASE_URL + "/seguranca/cadastro/usuario",
      name: "CADUSUARIO_MENU",
      component: () => import("@/paginas/seguranca/usuario/CadastroUsuario.vue"),
      meta: {
        auth: ['CADUSUARIO_MENU'],
      }
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/seguranca/cadastro/perfil",
      name: "cadastroPerfilUsuario",
      component: () => import("@/paginas/seguranca/CadastroPerfil.vue"),
    }, {
      path: "/" + process.env.VUE_APP_BASE_URL + "/empregado/dadosEmpregado",
      name: "EMPREGADO_DADOS",
      component: () => import("@/paginas/seguranca/usuario/ContainerEmpregado.vue"),
      meta: {
        auth: ['EMPREGADO_DADOS'],
      }
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/empregado/dadosDoEmpregado",
      name: "emprego-dados",
      component: () =>
        import("@/paginas/parametrizacoes/tabPanelDadosEmpregado.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/empregado/vinculosEmpregado",
      name: "empregado-vinculos",
      component: () =>
        import("@/paginas/parametrizacoes/tabPanelVinculosEmpregadoPublico.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/empregado/perfilEmpregado",
      name: "empregado-perfil",
      component: () =>
        import(
          "@/paginas/parametrizacoes/tabPanelPerfilAcessoEmpregadoPublico.vue"
        ),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/ciclo",
      name: "GESTAOPESSOA_MENU",
      component: () => import("@/paginas/gerenciaCiclo/ciclos.vue"),
      meta: {
        auth: ['GESTAOPESSOA_MENU'],
      }
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/ciclos",
      name: "ciclos",
      component: () => import("@/paginas/gerenciaCiclo/cicloContainer.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "gerenciaCiclo",
      name: "gerenciaCiclo",
      component: () => import("@/paginas/gerenciaCiclo/gerenciaCiclo.vue"),
    },
    ,
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "gerenciaCiclo/etapasCiclo",
      name: "etapasCiclo",
      component: () => import("@/paginas/gerenciaCiclo/etapasCiclo.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/termo",
      name: "termoaceiterecadastramento",
      component: () => import("@/paginas/recadastramento/termoAceiteLGPDP.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/prefeituraCba",
      name: "FORMPREFEITURA_MENU",
      component: () => import("@/paginas/formularioPrefeituraCba/listadoFormulario.vue"),
      meta: {
        auth: ['FORMPREFEITURA_MENU'],
      }
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/prefeituraCba/formulario",
      name: "FORMPREFEITURA_FORMULARIO",
      component: () => import("@/paginas/formularioPrefeituraCba/formularioCadastro.vue"),
      meta: {
        auth: ['FORMPREFEITURA_FORMULARIO'],
      }
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/faq",
      name: "RECADFAQ_MENU",
      component: () => import("@/paginas/FAQ.vue"),
      meta: {
        auth: ['RECADFAQ_MENU'],
      }
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/faleconosco",
      name: "RECADFALECONOSCO_MENU",
      component: () => import("@/paginas/FaleConosco.vue"),
      meta: {
        auth: ['RECADFALECONOSCO_MENU'],
      }
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/gerencia/validacao",
      name: "CHEFIAGERENCIA_VALIDACOES",
      component: () => import("@/paginas/gerencia/validacao.vue"),
      meta: {
        auth: ['CHEFIAGERENCIA_VALIDACOES'],
      }
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/gerencia/relatorios",
      name: "GERENCIARELATORIO_MENU",
      component: () => import("@/paginas/gerencia/relatorios.vue"),
      meta: {
        auth: ['GERENCIARELATORIO_MENU'],
      }
    },
    {
      path:
        "/" + process.env.VUE_APP_BASE_URL + "/gerencia/regularizacaoServidor",
      name: "REGULARIZACAOSERVIDORES_MENU",
      component: () => import("@/paginas/regularizacaoServidor/regularizacaoServidor.vue"),
      meta: {
        auth: ['REGULARIZACAOSERVIDORES_MENU'],
      }
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/administrativo/ciclos",
      name: "listaCiclo",
      component: () => import("@/paginas/gerenciaSistemica/listaCiclo.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/administrativo/novoCiclos",
      name: "gerenciaNovoCiclo",
      component: () => import("@/paginas/gerenciaSistemica/novoCiclo.vue"),
    },
    {
      path:
        "/" + process.env.VUE_APP_BASE_URL + "/administrativo/novoQuestionario",
      name: "gerenciaNovoQuestionario",
      component: () =>
        import("@/paginas/gerenciaSistemica/novoQuestionario.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/administrativo/novoQuestionario/novapergunta",
      name: "novoQuestionarioPergunta",
      component: () =>
        import("@/paginas/gerenciaSistemica/novoQuestionarioPergunta.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/administrativo/novoQuestionario/novapergunta/opçoesPergunta",
      name: "manterOpcoesPergunta",
      component: () =>
        import("@/paginas/gerenciaSistemica/manterOpcoesPergunta.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/administrativo/visualizarciclo",
      name: "visualizarCiclo",
      component: () =>
        import("@/paginas/gerenciaSistemica/visualizarCiclo.vue"),
    },
    ...gestaoPessoaRouter,
    ...recadastramentoRouter,
    ...recadastramentoViewRouter,
    ...gerenciaChefiaRouter,
    ...cadastroUsuarioRouter
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  let liberatudo = false;

  if (to.name == "recadastramento" ||
    liberatudo ||
    (to.name &&
      to.name.split("-").length > 0 &&
      to.name.split("-")[1] == "publico")
  ) {
    return next();

  }

  if (store.getters.getUser) {
    let authorities = store.getters.getUser.contaAcesso.authorities.map((role) => role.nomeRole) || [];
    let direitosDinamicos = store.getters.getUser.contaAcesso.direitosDinamicos.map((role) => role.nomeRole) || [];


    let listAuthorities = [
      ...authorities,
      ...direitosDinamicos
    ]
    let listaTelaAuth = to.meta.auth || []

    if (listaTelaAuth.length > 0) {
      if (listaTelaAuth.every(auth => listAuthorities.includes(auth))) {
        return next();
      }
      else {
        console.log("error ");
        console.log("não achou", to, ' na lista ');
        console.log("a lista é ", listAuthorities);
      }
    } else {
      return next();
    }

  }

  return next({ name: "recadastramento" });


  // if (to.name == "recadastramento" ||
  //   liberatudo ||
  //   (to.name &&
  //     to.name.split("-").length > 0 &&
  //     to.name.split("-")[1] == "publico")
  // ) {
  //   next();
  // } else if (store.getters.getUser) {
  //   let perfilUsers = store.getters.getUser.contaAcesso.direitosDinamicos;
  //   let possuiAcesso = false;


  //   if (perfilUsers.length <= 0) {
  //     let verifica = paginasChefia.filter(function (element) {
  //       return element == to.name;
  //     });
  //     if (!verifica || verifica.length <= 0) {
  //       possuiAcesso = true;
  //     }
  //   } else {
  //     for (let i = 0; i < perfilUsers.length; i++) {
  //       let permissao = perfis.filter(function (element) {
  //         return element.perfil == perfilUsers[i].nomeRole;
  //       });
  //       if (permissao.length > 0) {
  //         let verifica = permissao[0].permissoes.filter(function (element) {
  //           possuiAcesso = true;
  //           return element == to.name;
  //         });
  //         if (verifica && verifica.length > 0) {
  //           possuiAcesso = true;
  //           break;
  //         }
  //       }
  //     }
  //   }


  //   if (possuiAcesso) {
  //     next();
  //   } else {
  //     //VALIDACAO AUTORIDADES
  //     let perfilUsers = store.getters.getUser.contaAcesso.authorities;
  //     let perfilUsers2 = store.getters.getUser.contaAcesso.direitosDinamicos;


  //     if (perfilUsers2 && perfilUsers2.length > 0) {
  //       let teste = [...perfilUsers, ...perfilUsers2];
  //       let verifica = teste.filter(function (element) {
  //         return element.nomeRole == to.name;
  //       });
  //       if (verifica && verifica.length > 0) {
  //         possuiAcesso = true;
  //       }
  //     } else if (perfilUsers && perfilUsers.length > 0) {
  //       let verifica = perfilUsers.filter(function (element) {
  //         return element.nomeRole == to.name;
  //       });
  //       if (verifica && verifica.length > 0) {
  //         possuiAcesso = true;
  //       }
  //     } else {
  //       for (let i = 0; i < perfilUsers.length; i++) {
  //         let permissao = perfis.filter(function (element) {
  //           return element.perfil == perfilUsers[i].nomeRole;
  //         });
  //         if (permissao.length > 0) {
  //           let verifica = permissao[0].permissoes.filter(function (element) {
  //             return element == to.name;
  //           });
  //           if (verifica && verifica.length > 0) {
  //             possuiAcesso = true;
  //             break;
  //           }
  //         }
  //       }
  //     }
  //   }

  //   if (possuiAcesso) {
  //     next();
  //   } else {
  //     Vue.prototype.$toast.add({
  //       severity: "error",
  //       summary: "Você não possui permissão para acessar essa página.",
  //       life: 10000,
  //     });
  //     next({ name: "recadastramento" });
  //   }
  // } else {
  //   next({ name: "recadastramento" });
  // }


});


export default router;
